import { setDetailsKnowledgeItemToView } from "store/global/global.actions";
import { takeLatest, put, call, select } from "redux-saga/effects";
import { generatePath } from "react-router-dom";
import BackendClient from "api/backend-client";
import { RecipeScalingApiMethods } from "api/api-methods";
import { waitForLogin } from "store/auth/auth.saga";
import { loadLicensesListSaga } from "store/licensing/licensing.saga";
import { RsWorkspaceListActionType, loadWorkspacesListFailure, loadWorkspacesListSuccessful, uploadWorkspaceFailure, uploadWorkspaceSuccessful, parseWorkspaceFileIdFailure, parseWorkspaceFileIdSuccessful, parseWorkspaceFileId, workspaceImportFromFileIdFailure, workspaceImportFromFileIdSuccessful, getWorkspaceDetailsFailure, } from "./rs-workspace-list.actions";
import { setCurrentRequestTemplate, setServerError, } from "store/knowledge-base-item/knowledge-base-item.actions";
import { RequestTemplate } from "store/knowledge-base-item/knowledge-base-item.types";
import RoutePaths from "routes/route-paths";
import { workspaceImportFileIdSelector } from "./rs-workspace-list.selectors";
import { getWorkspaceStateSelector } from "store/rs-workspace/selectors/rs-workspace.selectors";
import { detailsKnowledgeItemToViewSelector } from "store/global/global.selectors";
import { GlobalEntityType } from "shared/types";
import { apiErrorHandler } from "store/global/global.saga";
import { navigate } from "shared/navigation";
export function* loadWorkspacesSaga() {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        const data = yield call([
            backendClient,
            RecipeScalingApiMethods.GetRsWorkspacesList,
        ]) || [];
        yield put(loadWorkspacesListSuccessful(data));
    }
    catch (e) {
        yield call(apiErrorHandler, e, "workspace load failed");
        yield put(loadWorkspacesListFailure());
        throw e;
    }
}
function* workspaceImportUploadSaga({ payload }) {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        yield put(setCurrentRequestTemplate(RequestTemplate.IMPORT_UPLOAD));
        const state = {
            fileName: payload.name,
            entity: GlobalEntityType.RsWorkspace,
        };
        navigate(RoutePaths.ImportRecipeScalingWorkspace, state);
        const formData = new FormData();
        formData.append("file", payload, payload.name);
        const importFileId = yield call([backendClient, RecipeScalingApiMethods.RsWorkspaceUpload], formData);
        yield put(uploadWorkspaceSuccessful(importFileId));
        yield put(parseWorkspaceFileId(importFileId));
    }
    catch (e) {
        yield call(apiErrorHandler, e, "workspace upload failed");
        yield put(uploadWorkspaceFailure());
    }
}
function* parseWorkspaceFileIdSaga({ payload }) {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        yield put(setCurrentRequestTemplate(RequestTemplate.IMPORT_FILE_PARSE));
        const { content, errors } = yield call([backendClient, RecipeScalingApiMethods.RsWorkspaceParseFile], payload);
        yield put(parseWorkspaceFileIdSuccessful(content));
        if (errors) {
            yield put(setCurrentRequestTemplate(RequestTemplate.IMPORT_FILE));
            yield put(setServerError({
                error: {
                    status: 400,
                    data: { errors: errors.errors },
                },
            }));
        }
    }
    catch (e) {
        yield call(apiErrorHandler, e, "workspace parse failed");
        yield put(parseWorkspaceFileIdFailure());
    }
}
function* workspaceImportFromFileIdSaga({ payload }) {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        const importFileId = yield select(workspaceImportFileIdSelector);
        yield put(setCurrentRequestTemplate(RequestTemplate.IMPORT_FILE));
        const workspaceId = yield call([backendClient, RecipeScalingApiMethods.RsWorkspaceImportFromFileId], importFileId, payload);
        navigate(generatePath(RoutePaths.EditRecipeScalingWorkspace, { id: workspaceId }), null, true);
        yield call(loadLicensesListSaga);
        yield put(workspaceImportFromFileIdSuccessful());
    }
    catch (e) {
        yield call(apiErrorHandler, e, "workspace import failed");
        yield put(workspaceImportFromFileIdFailure());
    }
}
export function* workspaceGetDetailsSaga({ payload }) {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        const { id, fetch } = payload;
        let data;
        if (fetch) {
            data = yield call([backendClient, RecipeScalingApiMethods.GetRsWorkspace], id);
        }
        else {
            const state = yield select(getWorkspaceStateSelector);
            const item = yield select(detailsKnowledgeItemToViewSelector);
            data = { ...item, state };
        }
        yield put(setDetailsKnowledgeItemToView(data));
    }
    catch (e) {
        yield call(apiErrorHandler, e, "workspace get details failed");
        yield put(getWorkspaceDetailsFailure());
        throw e;
    }
}
export default function* psWorkspaceListSaga() {
    yield takeLatest(RsWorkspaceListActionType.LOAD_LIST, loadWorkspacesSaga);
    yield takeLatest(RsWorkspaceListActionType.UPLOAD_WORKSPACE, workspaceImportUploadSaga);
    yield takeLatest(RsWorkspaceListActionType.PARSE_WORKSPACE_FILE_ID, parseWorkspaceFileIdSaga);
    yield takeLatest(RsWorkspaceListActionType.WORKSPACE_IMPORT_FROM_FILE_ID, workspaceImportFromFileIdSaga);
    yield takeLatest(RsWorkspaceListActionType.WORKSPACE_GET_DETAILS, workspaceGetDetailsSaga);
}
